import React from 'react';
import {
  Box,
  Typography,
  Switch,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';

function ChatHeader({ useStreaming, setUseStreaming }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Divider />
      <Box
        sx={{
          p: isMobile ? 0.75 : 1,
          display: 'flex',
          alignItems: 'center',
          gap: isMobile ? 0.5 : 1,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: isMobile ? '0.65rem' : '0.75rem' }}
        >
          Mode streaming:
        </Typography>
        <Switch
          checked={useStreaming}
          onChange={(e) => setUseStreaming(e.target.checked)}
          size="small"
        />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: isMobile ? '0.65rem' : '0.75rem' }}
        >
          {useStreaming ? 'Activé' : 'Désactivé'}
        </Typography>
      </Box>
    </>
  );
}

export default ChatHeader;
